
<template>
  <b-card no-body>

      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <b-card-title>Objectif</b-card-title>
        </div>
        <b-form-select
            id="yearSelect"
            v-model="currentYear"
            size="sm"
            :options="yearOptions"
            class="budget-dropdown"
        />
      </div>

      <b-card-body>

        <b-row>
          <b-col
              sm="6"
              order-sm="1"
              order="2"
              class="d-flex justify-content-between flex-column mt-1 mt-sm-0"
          >
            <div>
              <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
                {{ dataObjectif.totalToDo }}
              </h1>
              <small>Total à faire</small>
            </div>


            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="shadow"
                @click="$router.push({
                  name: 'user-stay-doing-objectives',
                  params: { year }
                })"

            >
              <span>Reste à faire </span>
              <feather-icon icon="ChevronsRightIcon" />
            </b-button>
          </b-col>

          <!-- chart  sm="6"
              class="d-flex justify-content-center"-->
          <b-col
              sm="6"
              cols="12"
              order-sm="2"
              order="1"
              class="d-flex justify-content-between flex-column text-right"
          >

            <!-- apex chart -->
            <vue-apex-charts
                type="radialBar"
                height="270"
                :options="supportTrackerRadialBar.chartOptions"
                :series="dataObjectif.validated"
            />
          </b-col>
          <!--/ chart -->
        </b-row>
        <hr>

        <b-row class="avg-sessions pt-50">
          <b-col
              cols="6"
              class="mb-2"
          >
            <b-card-text class="mb-50">
              Proposés : {{ dataObjectif.proposed }}
            </b-card-text>
            <b-progress
                :value="dataObjectif.proposed"
                :max="dataObjectif.totalToDo"
                height="6px"
            />
          </b-col>
          <b-col
              cols="6"
              class="mb-2"
          >
            <b-card-text class="mb-50">
              Validés par N+1 : {{ dataObjectif.approved }}
            </b-card-text>
            <b-progress
                :value="dataObjectif.approved"
                :max="dataObjectif.totalToDo"
                height="6px"
                variant="success"
            />
          </b-col>
          <b-col cols="6">
            <b-card-text class="mb-50">
              Transférés au N+2 : {{ dataObjectif.transferred }}
            </b-card-text>
            <b-progress
                :value="dataObjectif.transferred"
                :max="dataObjectif.totalToDo"
                height="6px"
                variant="warning"
                class="mt-25"
            />
          </b-col>
          <b-col cols="6">
            <b-card-text class="mb-50">
              Rejetés : {{ dataObjectif.rejected }}
            </b-card-text>
            <b-progress
                :value="dataObjectif.rejected"
                :max="dataObjectif.totalToDo"
                variant="danger"
                height="6px"
                class="mt-25"
            />
          </b-col>
        </b-row>
      </b-card-body>

  </b-card>
</template>

<script>
import {
  BCard, BProgress, BCardTitle, BCardBody, BRow, BCol, BCardText, BFormSelect,BButton
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import { getCountByStatusAndYearsByObjectif } from "@/services/UserObjectiveService";
import { getSetting } from "@/services/SettingService";
import { allYears } from "@/services/YearsService";
import Ripple from 'vue-ripple-directive';

export default {
  directives: {
    Ripple,
  },
  components: {
    BFormSelect,
    VueApexCharts,
    BCard,
    BButton,
    BProgress,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
  },

  data() {
    return {
      supportTrackerRadialBar: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: { size: '65%' },
              track: { background: '#fff', strokeWidth: '100%' },
              dataLabels: {
                name: { offsetY: -5, color: '#5e5873', fontSize: '1rem' },
                value: { offsetY: 15, color: '#5e5873', fontSize: '1.714rem' },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: { dashArray: 8 },
          labels: ['Objectifs Validé'],
        },
      },
      dataObjectif: { },
      currentYear: null,
      years: [],
      year:null,

    }
  },

  computed: {
    yearOptions() {
      return this.years.map(year => ({ value: year.year, text: `${year.year}` }));
    },
  },

  watch: {
    currentYear(newYear) {
      if (newYear) {
        this.getCountByStatusAndYearsByObjectif(newYear);
      }
    },
  },

  methods: {
    async getCountByStatusAndYearsByObjectif(year) {
      const y = year || this.currentYear;
      if (!y) return; // ne rien faire si aucune année définie

      try {
        this.year = y;
        this.dataObjectif = await getCountByStatusAndYearsByObjectif(y);
      } catch (error) {
        console.error('Erreur API Objectif:', error.response ? error.response.data : error);
      }
    },

    async getAllYears() {
      try {
        this.years = await allYears();
        if (!this.currentYear && this.years.length) {
          this.currentYear = this.years[0].year;
          // API après avoir défini currentYear
          await this.getCountByStatusAndYearsByObjectif();
        }
      } catch (error) {
        console.error('Erreur récupération années:', error);
      }
    },

    async settings() {
      try {
        const response = await getSetting();
        if (response && response.yearObjective) {
          this.currentYear = response.yearObjective?.year;
          // API après avoir défini currentYear
          await this.getCountByStatusAndYearsByObjectif();
        }
      } catch (error) {
        console.error('Erreur récupération settings:', error);
        if (!this.currentYear && this.years.length) {
          this.currentYear = this.years[0].year;
          await this.getCountByStatusAndYearsByObjectif();
        }
      }
    },
  },

  mounted() {
    this.getAllYears();
    this.settings();
  }
}
</script>

<style scoped>
.budget-dropdown {
  width: 80px;
  border: 1px solid #005cb9;
  border-radius: 0.357rem;
  background-color: #fff;
  font-size: 1rem;
  line-height: 1.45;
  color: #005cb9;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.budget-dropdown:focus,
.budget-dropdown:active {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.2);
  outline: none;
}
</style>